import {
    deleteFuelRobItem,
    getAllFuelRobItems,
    deleteBunkeringItem,
    getAllBunkeringItems,
    deleteBunkeringStatusItem,
    getAllBunkeringStatusItems,
    deleteBunkerLossItem,
    getAllBunkerLossItems,
} from 'src/api/bunkering/offlineBunkeringApi';
import useSyncHelper from './useSyncHelper';
import { useSWService } from 'src/api/sw/useSWService';

const useSyncOfflineBunkering = () => {
    const { syncItems } = useSyncHelper();
    const { refreshRequestsContaining } = useSWService();

    const syncFuelRobItems = () => syncItems(getAllFuelRobItems, deleteFuelRobItem, ['upsertFuelRobDataRequest'], 'aolDate');
    const syncBunkeringItems = () =>
        syncItems(getAllBunkeringItems, deleteBunkeringItem, ['upsertBunkeringRequest', 'upsertDebunkeringRequest'], 'bunkeringGuid');
    const syncBunkeringStatusItems = () =>
        syncItems(
            getAllBunkeringStatusItems,
            deleteBunkeringStatusItem,
            ['upsertBunkeringStatusRequest', 'deleteBunkeringStatusRequest'],
            'bunkeringStatusGuid'
        );
    const syncBunkerLossItems = () => syncItems(getAllBunkerLossItems, deleteBunkerLossItem, ['upsertBunkerLossDataRequest'], 'bunkerLossKey');

    const syncBunkerings = async (skipRefresh?: boolean | null) => {
        await syncFuelRobItems();
        await syncBunkeringItems();
        await syncBunkeringStatusItems();
        await syncBunkerLossItems();

        if (!skipRefresh) {
            await refreshRequestsContaining(['GetBunkerings', 'GetFuelRobData', 'GetBunkerLossData']);
        }

        // The SW's refreshRequestsContaining above only re-fetches whichever URL variant it
        // guesses was most recently cached for each endpoint, then does a full-array replace of
        // context - a fragile mechanism that can pick a URL not matching what's currently
        // rendered, or simply never fire again if nothing about the page's own reconciliation
        // effect's dependencies happen to change around this exact moment. Dispatching this event
        // lets pages that own the real, currently-correct query params (imoNumber/noonReportIds/
        // bunkeringGuids) - BunkeringPage.tsx and AolMain.tsx - deterministically re-fetch ROB/
        // Bunker Loss data with those guaranteed-correct params right after sync completes,
        // instead of depending on that guesswork as the sole self-correction mechanism.
        window.dispatchEvent(new CustomEvent('bunkering-data-synced'));
    };

    return {
        syncBunkerings,
    };
};

export default useSyncOfflineBunkering;
